import React from 'react'

import { printContactOption } from './styles'
import { Icon, IconSize } from 'sidecar-components/atoms/Icon'
import { Link, LinkType } from 'sidecar-components/atoms/Link'
import { PrintHeaderProps } from './PrintHeader.types'

export const PrintHeader = ({ authenticated }: PrintHeaderProps) => {
  return (
    <ul className={`hidden ${authenticated && 'print:block'}`}>
      <li className={printContactOption}>
        <Icon name="phone" size={IconSize.XS} className="color-icon-default" />
        <Link path="tel:855-346-4846" type={LinkType.CONTACT}>
          855-346-4846
        </Link>
      </li>
      <li className={printContactOption}>
        <Icon name="email" size={IconSize.XS} className="color-icon-default" />
        <Link path="mailto:claims@sidecarhealth.com" type={LinkType.CONTACT}>
          claims@sidecarhealth.com
        </Link>
      </li>
      <li className={printContactOption}>
        <Icon name="pin" size={IconSize.XS} className="color-icon-default" />
        P.O. Box 21202
        <br />
        Eagan, MN 55121
      </li>
    </ul>
  )
}
